import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 64834 52826"
    {...props}
  >
    <path
      d="m400 52509 32016-35281 32018 35281L32416 894z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 941.667,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
